import { commerceApi, ECustomerAuthorizationEndpoints } from '../api';
import { EGerdauService } from '../EGerdauService';
import {
  ICMSResponse,
  IProductFindParam,
  IProductInfo,
  IRelatedProducts
} from './types';
import { EndpointsMvp } from '../MVP/enum';
import { AxiosInstance } from 'axios';

export class ProductService extends EGerdauService {
  constructor() {
    super();
  }

  async getProduct(params: IProductFindParam): Promise<IProductInfo[]> {
    const headers = new EGerdauService().getHeaders();

    const service = params.api || commerceApi;

    const requestURL = `${ECustomerAuthorizationEndpoints.PRODUCTS}/${params.sku}?soldTo=${params.soldTo}&shipTo=${params.shipTo}`;
    const response = await service.get(requestURL, {
      headers
    });
    return response.data;
  }

  async getRelatedProducts(
    params: IProductFindParam
  ): Promise<IRelatedProducts> {
    const headers = new EGerdauService().getHeaders();

    const service = params.api || commerceApi;

    const requestURL = `${ECustomerAuthorizationEndpoints.PRODUCTS}/${params.sku}/relatedProducts?soldTo=${params.soldTo}&shipTo=${params.shipTo}`;
    const response = await service.get(requestURL, {
      headers
    });
    return { related: response.data };
  }

  async getProductArticle(
    categoryName: string,
    api?: AxiosInstance
  ): Promise<ICMSResponse> {
    const headers = new EGerdauService().getHeaders();
    const field = 'url_key';
    const conditionType = 'eq';

    const service = api || commerceApi;

    const requestURL = `/commerce${EndpointsMvp.CATEGORIES_LIST(
      field,
      categoryName,
      conditionType
    )}`;
    const response = await service.get(requestURL, {
      headers
    });

    return response.data.items[0];
  }
}
